/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ at: NonNullable<unknown> }} Jobs_StartedInputs */

const cs_jobs_started = /** @type {(inputs: Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spuštěno ${i?.at}`)
};

const en_jobs_started = /** @type {(inputs: Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Started ${i?.at}`)
};

/**
* | output |
* | --- |
* | "Started {at}" |
*
* @param {Jobs_StartedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_started = /** @type {((inputs: Jobs_StartedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_StartedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_started(inputs)
	return cs_jobs_started(inputs)
});